<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-button type="primary" @click="pageChange(1)" size="mini">搜索</el-button>
      <el-input v-model="query.account_name" placeholder="供应商名称" style="width:200px" size="mini" @change="pageChange(1)" />
      <el-input v-model="query.yy_code" placeholder="用友编号" style="width:200px" size="mini" @change="pageChange(1)" />
      <el-select size="mini" placeholder="状态" v-model="query.enabled" @change="pageChange(1)">
        <el-option label="启用" value="1"></el-option>
        <el-option label="禁用" value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="handleAdd" size="mini">新增</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="80" fixed />
      <el-table-column prop="account_name" label="账号名称" min-width="250" fixed />
      <el-table-column prop="yy_code" label="用友编码" width="180" />
      <el-table-column prop="bank_name" label="开户行" min-width="200" />
      <el-table-column prop="cbs_bank_name" label="开户行（CBS）" min-width="200" />
      <el-table-column prop="cbs_bank_code" label="联行号" width="200" />
      <el-table-column prop="bank_type" label="银行类型" width="100" />
      <el-table-column prop="owner_type" label="所有方类型" width="100" />
      <el-table-column prop="account_no" label="账号" width="200" />
      <el-table-column prop="org" label="开户单位编码" width="200" />
      <el-table-column prop="enabled" label="状态" width="100">
        <template slot-scope="scope">
<!--          <el-switch v-model="scope.row.enabled" active-text="启用" inactive-text="禁用" :active-value="1" :inactive-value="0" size="mini"></el-switch>-->
          <el-tag v-if="scope.row.enabled === 1" size="mini" type="success">启用</el-tag>
          <el-tag v-if="scope.row.enabled === 0" size="mini" type="danger">禁用</el-tag>
        </template>
      </el-table-column>


      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
<!--          <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next,sizes"
      :total="pageData.total"
      :page-sizes="[10, 20, 50, 100]"
      style="margin-top:15px;text-align:right"
    />

    <!--
    //  `id` int(11) NOT NULL AUTO_INCREMENT,
    //  `yy_code` varchar(50) DEFAULT NULL COMMENT '用友账号',
    //  `account_name` varchar(255) DEFAULT NULL COMMENT '账号名称',
    //  `bank_name` varchar(50) DEFAULT NULL COMMENT '开户行',
    //  `cbs_bank_name` varchar(255) DEFAULT NULL COMMENT '开户行（CBS）',
    //  `cbs_bank_code` varchar(50) DEFAULT NULL COMMENT '联行号',
    //  `bank_type` varchar(50) DEFAULT NULL COMMENT '银行类型',
    //  `bank_type_id` int(11) DEFAULT NULL COMMENT '类型ID',
    //  `owner_type` varchar(20) DEFAULT NULL COMMENT '所有方类型',
    //  `owner_id` int(11) DEFAULT NULL COMMENT '所有方 ID',
    //  `account_no` varchar(50) DEFAULT NULL COMMENT '账号',
    //  `org` varchar(255) DEFAULT NULL COMMENT '开户单位编码',
    //  `enabled` tinyint(1) DEFAULT '1' COMMENT '状态1=启用（默认），0=禁用',
    -->

    <!-- 新增/编辑弹窗 -->
    <el-dialog :visible.sync="dialogVisible" title="用户信息" width="800px">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="用友编号">
          <el-input v-model="form.yy_code" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="账号名称">
          <el-input v-model="form.account_name" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="开户行">
          <el-input v-model="form.bank_name" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="开户行（CBS）">
          <el-input v-model="form.cbs_bank_name" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="联行号">
          <el-input v-model="form.cbs_bank_code" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="银行类型">
          <el-input v-model="form.bank_type" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="所有方类型">
          <el-input v-model="form.owner_type" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="账号">
          <el-input v-model="form.account_no" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="开户单位编码">
          <el-input v-model="form.org" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-switch v-model="form.enabled" active-text="启用" inactive-text="禁用" :active-value="1" :inactive-value="0" size="mini"></el-switch>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'BankAccounts',
  data() {
    return {
      query: {
        account_name: "",
        yy_code: "",
        enabled: "",
      },
      pageData:{
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {
        id: 0,
        yy_code: "",
        account_name: "",
        bank_name: "",
        cbs_bank_name: "",
        cbs_bank_code: "",
        bank_type: "",
        owner_type: "",
        account_no: "",
        org: "",
        enabled: 1,
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // ====================== 获取列表 ======================
    getList() {
      const params = Params.ins()
        .where(this.query.account_name ? ['account_name', 'like', '%' + this.query.account_name + '%'] : null)
        .where(this.query.yy_code ? ['company_code', '=', this.query.company_code] : null)
        .where(this.query.enabled ? ['enabled', '=', this.query.enabled] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('BankAccounts/index', params, res => {
        if(res.code===200){
          this.pageData = res.data
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },

    // 新增
    handleAdd() {
      this.form = {
        id: 0,
        account_name:  '',
        yy_code: '',
        bank_name: '',
        cbs_bank_name: '',
        cbs_bank_code: '',
        bank_type: '',
        owner_type: '',
        account_no: '',
        org: '',
        enabled: 1,
      }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(id) {
      Http.post('BankAccounts/detail', Params.ins().detail(id), res => {
        if(res.code===200){
          this.form = res.data
          this.dialogVisible = true
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    // 提交保存
    submit() {
      if (!this.form.id) {
        this.form.id = 0
      }

      Http.post('BankAccounts/save', Params.ins().save(this.form), res => {
        if(res.code===200){
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getList()
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    // 删除
    handleDelete(id) {
      const that=this;
      that.$confirm('确定删除？').then( () => {

        Http.post('BankAccounts/delete', Params.ins().delete(id), res => {
          if(res.code===200){
            this.$message.success('删除成功')
            this.getList()
          }else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })

      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body{
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/FinancialCenter/BankAccounts.vue